export const GET_SYSTEM_LOG = 'ls00-log/ls01-get-log-details';
export const GET_ACTION_MENU = 'ls00-log/ls02-get-action-menu';
